import type { ConfigDoProduto, ProdutoDoRelatorio } from '../types';
import { configDaNegociacao } from './negociacao';
import { configDaNotificacao } from './notificacao';

export const CONFIG_DOS_PRODUTOS: Record<ProdutoDoRelatorio, ConfigDoProduto> = {
  negociacao: configDaNegociacao,
  notificacao: configDaNotificacao,
};
